import * as IMG from '../helpers/ImagesUtils';

const createRoute = (title, iconSrc, alt, to) => ({
  title,
  icon: <img src={iconSrc} width="25" height="25" alt={alt} />,
  to,
});

/*========================================================
/ Authentication
/======================================================== */
export const login = createRoute(
  'Inicio de sesion',
  'fa fa-user',
  'user',
  '/login',
);
export const register = createRoute(
  'Registro',
  'fa fa-user',
  'user',
  '/register',
);
export const recover = createRoute(
  'Recuperar Contraseña',
  '',
  '',
  '/recoverPassword',
);
export const confirmEmail = createRoute(
  'Confirmar Correo',
  '',
  '',
  '/confirmEmail',
);

export const dashboard = {
  title: 'Panel de Control',
  icon: <img src={IMG.vistas} width="25" height="25" alt="vistas" />,
  to: '/dashboard',
};

export const root = {
  title: 'On EDU',
  icon: <img src={IMG.superUser} width="25" height="25" alt="super" />,
  to: '/onedu',
};

export const carnetOnEdu = {
  title: 'Carnetización',
  icon: <img src={IMG.carnet} width="25" height="25" alt="carnet" />,
  to: `${root.to}/carnetizacion`,
};

export const usuarios = {
  id: 7,
  title: 'Usuarios',
  icon: <img src={IMG.usuarios} width="25" height="25" alt="usuarios2" />,
  to: `${root.to}/usuarios`,
};

export const entidades = {
  id: 3,
  title: 'Entidades',
  icon: <img src={IMG.entidad} width="25" height="25" alt="entidad" />,
  to: `${root.to}/entidades`,
};
export const panelEntidad = {
  id: 3,
  title: 'Panel de entidad',
  icon: <img src={IMG.entidad} width="25" height="25" alt="entidad" />,
  to: `${entidades.to}/panel`,
};

export const misEntidades = {
  id: '1x1',
  title: 'Mis entidades',
  icon: <img src={IMG.entidad} width="25" height="25" alt="entidad" />,
  to: `/mis_entidades`,
};
export const carreras = {
  id: 13,
  title: 'Carreras',
  icon: <img src={IMG.carreras} width="25" height="25" alt="carreras" />,
  to: `${root.to}/carreras`,
};
export const modulos = {
  id: 1,
  title: 'Módulos',
  icon: <img src={IMG.modulos} width="25" height="25" alt="modulos" />,
  to: `${root.to}/modulos`,
};
export const system = {
  id: 1,
  title: 'Sistema',
  icon: <img src={IMG.modulos} width="25" height="25" alt="system" />,
  to: `${root.to}/system`,
};
export const monedas = {
  title: 'Monedas',
  icon: <img src={IMG.monedas} width="25" height="25" alt="Monedas" />,
  to: `${root.to}/monedas`,
};
export const vistas = {
  id: 2,
  title: 'Vistas',
  icon: <img src={IMG.vistas} width="25" height="25" alt="vistas" />,
  to: `${root.to}/vistas`,
};

export const suscripciones = {
  id: 4,
  title: 'Suscripciones',
  icon: (
    <img src={IMG.suscripciones} width="25" height="25" alt="suscripciones" />
  ),
  to: `${root.to}/suscripciones`,
};
export const pagosSuscripcion = {
  id: 5,
  title: 'Pagos de Suscripción',
  icon: (
    <img src={IMG.suscripciones} width="25" height="25" alt="suscripciones" />
  ),
  to: `${suscripciones.to}/pagos`,
};
export const operadoras = {
  title: 'Operadoras',
  icon: <img src={IMG.operador} width="25" height="25" alt="operador" />,
  to: `${root.to}/operadoras`,
};

export const perfiles = {
  id: 6,
  title: 'Perfiles',
  icon: <img src={IMG.perfiles} width="25" height="25" alt="perfiles" />,
  to: `${root.to}/perfiles`,
};

export const profesiones = {
  id: 25,
  title: 'Profesiones',
  icon: <img src={IMG.profesiones} width="25" height="25" alt="profesiones" />,
  to: `${root.to}/profesiones`,
};

export const nivelesAcademicos = {
  id: 19,
  title: 'Niveles Académico',
  icon: <img src={IMG.periodos} width="25" height="25" alt="nivelAcademicos" />,
  to: `${root.to}/nivel_academicos`,
};

export const tiposActividadesExtraCur = {
  id: 34,
  title: 'Tipos Act. extracurriculares',
  icon: (
    <img
      src={IMG.actividadExtcur}
      width="25"
      height="25"
      alt="actividadExtcur"
    />
  ),
  to: `${root.to}/tipos_actividadesExtcur`,
};
export const controlEstudios = {
  title: 'Control de estudios',
  icon: <img src={IMG.fileuser} width="25" height="25" alt="fileuser" />,
  to: '/control_estudios',
};

export const boletines = {
  id: 40,
  title: 'Boletines',
  icon: <img src={IMG.certificado} width="25" height="25" alt="certificado" />,
  to: `${controlEstudios.to}/boletines`,
};
export const boletinesPdf = {
  id: 40,
  title: 'Boletines PDF',
  icon: <img src={IMG.certificado} width="25" height="25" alt="certificado2" />,
  to: `${boletines.to}/pdf`,
};

export const bloquesPedagogicos = {
  id: 29,
  title: 'Bloques pedagógicos',
  icon: <img src={IMG.bloques} width="25" height="25" alt="bloques" />,
  to: `${controlEstudios.to}/bloques_pedagogicos`,
};
export const panelBloquePedagogico = {
  id: 29,
  title: 'Panel de gestión',
  icon: <img src={IMG.bloques} width="25" height="25" alt="bloques" />,
  to: `${bloquesPedagogicos.to}/panel`,
};

export const secciones = {
  id: 14,
  title: 'Secciones',
  icon: <img src={IMG.secciones} width="25" height="25" alt="secciones" />,
  to: `${controlEstudios.to}/secciones`,
};
export const aulario = {
  id: 24,
  title: 'Aulario',
  icon: <img src={IMG.aulario} width="25" height="25" alt="aulario" />,
  to: `${controlEstudios.to}/aulario`,
};
export const matriculas = {
  id: 15,
  title: 'Matrículas',
  icon: <img src={IMG.matricula} width="25" height="25" alt="matricula" />,
  to: `${controlEstudios.to}/matriculas`,
};
export const panelMatriculas = {
  id: 15,
  title: 'Panel',
  subtitle: 'Panel de matrícula',
  icon: (
    <img src={IMG.matricula} width="25" height="25" alt="panel_matricula" />
  ),
  to: `${matriculas.to}/panel`,
};

export const planEvaluacion = {
  id: 30,
  title: 'Plan de evaluación',
  icon: (
    <img src={IMG.planevaluacion} width="25" height="25" alt="planevaluacion" />
  ),
  to: `${controlEstudios.to}/plan_evaluacion`,
};
export const panelPlanEvaluacion = {
  id: 30,
  title: 'Panel',
  subtitle: 'Panel plan de evaluación',
  icon: (
    <img src={IMG.planevaluacion} width="25" height="25" alt="planevaluacion" />
  ),
  to: `${planEvaluacion.to}/panel`,
};
export const actividadesExtras = {
  id: 30,
  title: 'Actividades Extras',
  icon: (
    <img
      src={IMG.planevaluacion}
      width="25"
      height="25"
      alt="actividadesExtras"
    />
  ),
  to: `${controlEstudios.to}/actividades_extras`,
};

export const panelActividadExtra = {
  id: 30,
  title: 'Panel',
  icon: (
    <img
      src={IMG.planevaluacion}
      width="25"
      height="25"
      alt="panelActividadExtra"
    />
  ),
  to: `${actividadesExtras.to}/panel`,
};

export const horarios = {
  id: 10,
  title: 'Horarios académico',
  icon: <img src={IMG.horario} width="25" height="25" alt="horarios" />,
  to: `${controlEstudios.to}/horarios`,
};
export const panelHorarios = {
  id: 10,
  title: 'Panel',
  icon: <img src={IMG.horario} width="25" height="25" alt="horarios" />,
  to: `${horarios.to}/panel`,
};

export const estudiantesDocentes = {
  id: 9,
  title: 'Estudiantes',
  icon: <img src={IMG.estudiante} width="25" height="25" alt="estudiante" />,
  to: `/estudiantes`,
};
export const estudiantes = {
  id: 9,
  title: 'Estudiantes',
  icon: <img src={IMG.estudiante} width="25" height="25" alt="estudiante" />,
  to: `${controlEstudios.to}/estudiantes`,
};
export const panelEstudiantes = {
  id: 9,
  title: 'Panel de estudiante',
  icon: <img src={IMG.estudiante} width="25" height="25" alt="estudiante" />,
  to: `${estudiantes.to}/panel`,
};

export const familiares = {
  id: 41,
  title: 'Familiares',
  icon: <img src={IMG.familia} width="25" height="25" alt="familiares" />,
  to: `${controlEstudios.to}/familiares`,
};
export const panelFamiliares = {
  id: 41,
  title: 'Panel de familiares',
  icon: <img src={IMG.familia} width="25" height="25" alt="familiares" />,
  to: `${familiares.to}/panel`,
};
export const familiaresPdf = {
  id: 41,
  title: 'Estudiantes PDF',
  icon: <img src={IMG.familia} width="25" height="25" alt="certificado2" />,
  to: `${familiares.to}/pdf`,
};

export const docentes = {
  id: 17,
  title: 'Docentes',
  icon: <img src={IMG.docentem} width="25" height="25" alt="adminm" />,
  to: `${controlEstudios.to}/docentes`,
};
export const panelDocentes = {
  id: 17,
  title: 'Panel de docentes',
  icon: <img src={IMG.adminm} width="25" height="25" alt="docente" />,
  to: `${docentes.to}/panel`,
};

export const periodosAcademicos = {
  id: 20,
  title: 'Períodos académicos',
  icon: <img src={IMG.periodos} width="25" height="25" alt="periodos" />,
  to: `${controlEstudios.to}/periodos_academicos`,
};

export const entNivelesAcademicos = {
  id: 19,
  title: 'Niveles académicos',
  icon: (
    <img
      src={IMG.gradosAcademicos}
      width="25"
      height="25"
      alt="gradosAcademicos"
    />
  ),
  to: `${controlEstudios.to}/niveles_academicos`,
};

export const materias = {
  id: 27,
  title: 'Materias',
  icon: <img src={IMG.materias} width="25" height="25" alt="materias" />,
  to: `${controlEstudios.to}/materias`,
};

export const asistenciasDiarias = {
  id: 35,
  title: 'Asistencias',
  icon: (
    <img
      src={IMG.asistenciasDiarias}
      width="25"
      height="25"
      alt="asistenciasDiarias"
    />
  ),
  to: `${controlEstudios.to}/asistencias_diarias`,
};

export const entCarreras = {
  id: 13,
  title: 'Carreras',
  icon: <img src={IMG.carreras} width="25" height="25" alt="entCarreras" />,
  to: `${controlEstudios.to}/carreras`,
};

/*========================================================
/ Accesos
/======================================================== */
export const accesos = {
  id: 26,
  title: 'Accesos de personas',
  icon: <img src={IMG.infoper} width="25" height="25" alt="infoper" />,
  to: '/accesos',
};
export const deportes = {
  id: 32,
  title: 'Deportes',
  icon: <img src={IMG.deportes} width="25" height="25" alt="deportes" />,
  to: '/deportes',
};
export const juegosDeportivos = {
  id: 38,
  title: 'Juegos deportivos',
  icon: <img src={IMG.deportes} width="25" height="25" alt="deportes" />,
  to: '/juegos_deportivos',
};
export const panelDeportivo = {
  id: 38,
  title: 'Panel deportivo',
  icon: <img src={IMG.club} width="25" height="25" alt="club" />,
  to: `${juegosDeportivos.to}/panel`,
};
export const resultados = {
  id: 38,
  title: 'Resultados',
  icon: <img src={IMG.posicion} width="25" height="25" alt="resultados" />,
  to: `${juegosDeportivos.to}/resultados`,
};
export const torneos = {
  id: 38,
  title: 'Torneos',
  icon: <img src={IMG.torneos} width="25" height="25" alt="torneos" />,
  to: `${juegosDeportivos.to}/torneos`,
};
export const panelTorneos = {
  id: 38,
  title: 'Panel de torneo',
  icon: <img src={IMG.torneos} width="25" height="25" alt="torneos" />,
  to: `${torneos.to}/panel`,
};
export const equipos = {
  id: 38,
  title: 'Equipos',
  icon: <img src={IMG.equipos} width="25" height="25" alt="equipos" />,
  to: `${juegosDeportivos.to}/equipos`,
};
export const panelEquipos = {
  id: 38,
  title: 'Panel de equipo',
  icon: <img src={IMG.equipos} width="25" height="25" alt="equipos" />,
  to: `${equipos.to}/panel`,
};
export const juegos = {
  id: 38,
  title: 'Juegos',
  icon: <img src={IMG.vs} width="25" height="25" alt="juegosvs" />,
  to: `${juegosDeportivos.to}/juegos`,
};
export const jugadores = {
  id: 38,
  title: 'Jugadores',
  icon: <img src={IMG.jugadores} width="25" height="25" alt="jugadores" />,
  to: `${juegosDeportivos.to}/jugadores`,
};
export const panelJuegos = {
  id: 38,
  title: 'Panel de equipo',
  icon: <img src={IMG.juegos} width="25" height="25" alt="juegos" />,
  to: `${juegos.to}/panel`,
};

export const carnet = {
  title: 'Carnetización',
  icon: <img src={IMG.carnet} width="25" height="25" alt="carnet" />,
  to: '/carnetizacion',
};

export const panelCarnet = {
  title: 'Panel',
  icon: <img src={IMG.carnet} width="25" height="25" alt="panelCarnet" />,
  to: `${carnet.to}/panel`,
};
export const carnetEstudiante = {
  title: 'Estudiantes',
  icon: (
    <img src={IMG.estudiante} width="25" height="25" alt="carnetEstudiantes" />
  ),
  to: `${carnet.to}/estudiantes`,
};
export const carnetPersonal = {
  title: 'Personal',
  icon: <img src={IMG.docentem} width="25" height="25" alt="carnetPersonal" />,
  to: `${carnet.to}/personal`,
};
/*========================================================
/ sistema - entidad
/======================================================== */

export const usuEntidades = {
  id: 7,
  title: 'Usuarios',
  icon: <img src={IMG.usuarios} width="25" height="25" alt="usuarios" />,
  to: '/usuarios',
};
export const panelUsuEntidades = {
  id: 7,
  title: 'Panel del usuario',
  icon: <img src={IMG.usuarios} width="25" height="25" alt="usuarios" />,
  to: `${usuEntidades.to}/panel`,
};

export const usuEntPerfiles = {
  id: 7,
  title: 'Perfiles del usuario',
  icon: <img src={IMG.perfiles} width="25" height="25" alt="perfiles" />,
  to: `${usuEntidades.to}/perfiles`,
};

export const usuProfesiones = {
  id: 7,
  title: 'Profesiones del usuario',
  icon: <img src={IMG.profesiones} width="25" height="25" alt="profesiones" />,
  to: `${usuEntidades.to}/profesiones`,
};

export const actividadesExtCur = {
  id: 33,
  title: 'Actividades extracurriculares',
  icon: (
    <img
      src={IMG.actividadExtcur}
      width="25"
      height="25"
      alt="actividadesExtCur"
    />
  ),
  to: `${usuEntidades.to}/actividades_extracurriculares`,
};

export const permisos = {
  id: 8,
  title: 'Permisos',
  icon: <img src={IMG.perfiles} width="25" height="25" alt="permisos" />,
  to: `${perfiles.to}/permisos`,
};

/*========================================================
/ Notas
/======================================================== */
export const notas = {
  id: 11,
  title: 'Notas',
  icon: <img src={IMG.notas} width="25" height="25" alt="notas" />,
  to: '/notas',
};

export const panelNotas = {
  id: 11,
  title: 'Panel',
  name: 'Panel de notas',
  icon: <img src={IMG.notas} width="25" height="25" alt="pay" />,
  to: notas.to,
};

export const notasBloped = {
  id: 11,
  title: 'Bloques pedagógicos',
  name: 'Notas por bloques pedagógicos',
  icon: (
    <img
      src={IMG.notasdefinitivas}
      width="25"
      height="25"
      alt="notasdefinitivas"
    />
  ),
  to: `${notas.to}/bloques_pedagogicos`,
};

export const notasEvaluativas = {
  id: 11,
  title: 'Notas evaluativas',
  icon: <img src={IMG.nota} width="25" height="25" alt="notasevaluativas" />,
  to: `${notas.to}/evaluativas`,
};

/*========================================================
/ Administracion
/======================================================== */
export const administracion = {
  id: 37,
  title: 'Administración',
  icon: <img src={IMG.pay} width="25" height="25" alt="pay" />,
  to: '/administracion',
};

export const panelAdministracion = {
  id: 37,
  title: 'Panel',
  name: 'Panel de administración',
  icon: <img src={IMG.pay} width="25" height="25" alt="pay" />,
  to: administracion.to,
};

export const conceptos = {
  id: 37,
  title: 'Conceptos de pagos',
  icon: <img src={IMG.conceptos} width="25" height="25" alt="conceptos" />,
  to: `${administracion.to}/conceptos`,
};

export const recibos = {
  id: 37,
  title: 'Recibos',
  icon: <img src={IMG.recibo} width="25" height="25" alt="recibo" />,
  to: `${administracion.to}/recibos`,
};
export const recibosPdf = {
  id: 37,
  title: 'Recibos PDF',
  icon: <img src={IMG.recibo} width="25" height="25" alt="recibospdf" />,
  to: `${recibos.to}/pdf`,
};

/*========================================================
/ Academicos
/======================================================== */
export const academico = {
  title: 'Académico',
  icon: <img src={IMG.bloques} width="25" height="25" alt="pay" />,
  to: '/academico',
};

export const herramientas = {
  id: '1x1',
  title: 'Herramientas',
  icon: (
    <img src={IMG.herramientaweb} width="25" height="25" alt="herramientas" />
  ),
  to: '/herramientas',
};

export const temasAcademicos = {
  id: 28,
  title: 'Temas académicos',
  icon: <img src={IMG.temas} width="25" height="25" alt="temas" />,
  to: `${academico.to}/temasAcademicos`,
};

export const evaluaciones = {
  id: 12,
  title: 'Evaluaciones académicas',
  icon: (
    <img src={IMG.evaluaciones} width="25" height="25" alt="evaluaciones" />
  ),
  to: `${academico.to}/evaluaciones`,
};

export const actividadesAcademicas = {
  id: 31,
  title: 'Actividades académicas',
  icon: (
    <img src={IMG.instrumentos} width="25" height="25" alt="instrumentos" />
  ),
  to: `${academico.to}/actividadesAcademicas`,
};

/*========================================================
/ Docentes
/======================================================== */
export const materiasDocentes = {
  title: 'Materias',
  icon: <img src={IMG.materias} width="25" height="25" alt="materias" />,
  to: `/materias`,
};

/*========================================================
/ Notas
/======================================================== */
export const tablero = {
  title: 'Tablero',
  icon: (
    <img src={IMG.instrumentos} width="25" height="25" alt="instrumentos" />
  ),
  to: '/tablero',
};

/*========================================================
/ Proceso mnaual
/======================================================== */
export const procesosManual = {
  title: 'Procesos Manual',
  icon: (
    <img src={IMG.instrumentos} width="25" height="25" alt="instrumentos" />
  ),
  to: '/procesos_manual',
};

/*========================================================
/ Ajustes
/======================================================== */
export const ajustes = {
  id: 18,
  title: 'Ajustes',
  icon: <img src={IMG.ajustes} width="25" height="25" alt="ajustes" />,
  to: '/ajustes',
};
export const entHorariosClases = {
  id: 10,
  title: 'Ajustes de horarios',
  icon: <img src={IMG.horario} width="25" height="25" alt="ajustesHorarios" />,
  to: `${ajustes.to}/horarios`,
};
export const entHorBloques = {
  id: 10,
  title: 'Ajustes de horarios',
  icon: <img src={IMG.horario} width="25" height="25" alt="ajustesHorarios" />,
  to: `${ajustes.to}/horarios`,
};
export const entHorarioClasesAjustes = {
  id: 10,
  title: 'Ajustes del horario',
  icon: <img src={IMG.horario} width="25" height="25" alt="ajustesHorarios" />,
  to: `${horarios.to}/ajustes`,
};
export const eventos = {
  id: 39,
  title: 'Eventos',
  icon: <img src={IMG.eventos} width="25" height="25" alt="eventos" />,
  to: '/eventos',
};

export const reportes = {
  id: 9991,
  title: 'Reportes',
  icon: <img src={IMG.reportes} width="25" height="25" alt="reportes" />,
  to: '/reportes',
};
export const resumenes = {
  id: 9992,
  title: 'Resumén final',
  icon: <img src={IMG.reportes} width="25" height="25" alt="resumenes" />,
  to: '/resumenes',
};

export const verificador = {
  title: 'Verificador',
  icon: <img src={IMG.vexcel} width="25" height="25" alt="verificador" />,
  to: '/verificador',
};

export const impresionCarnet = {
  title: 'Impresión de Carnet',
  icon: <img src={IMG.carnet} width="25" height="25" alt="carnet" />,
  to: '/impresion_carnet',
};

export const modulosSistema = [
  accesos, // 26
  actividadesAcademicas, // 31
  actividadesExtCur, // 33
  ajustes, // 18
  asistenciasDiarias, // 35
  aulario, // 24
  bloquesPedagogicos, // 29
  carreras, // 13
  // competencias, // 21
  deportes, // 32
  docentes, // 17
  entidades, // 3
  estudiantes, // 9
  evaluaciones, // 12
  // gradosNotas, // 23
  horarios, // 10
  juegosDeportivos, // 38,
  materias, // 27
  matriculas, // 15
  modulos, // 1
  nivelesAcademicos, // 19
  notas, // 11
  // orientacionEstudiantil, // 36
  pagosSuscripcion, // 5
  perfiles, // 6
  periodosAcademicos, // 20
  permisos, // 8
  // planEstudios, // 22
  planEvaluacion, // 30
  profesiones, // 25
  recibos, // 37
  secciones, // 14
  suscripciones, // 4
  // tareas, // 16
  temasAcademicos, // 28
  tiposActividadesExtraCur, // 34
  usuarios, // 7
  vistas, // 2
];
